export default [
  {
    name: 'validacao-duas-etapas',
    path: '/acesso/validacao-duas-etapas',
    component: () => import('@app/acesso/validacao-duas-etapas/ValidacaoDuasEtapas.vue'),
    meta: {
      resource: 'validacaoDuasEtapas',
      action: '',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
